export const homeObjOne = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'ÁREA',
    headLine: 'Proyectos Empresariales',
    description: 'En esta área del club nos enfocamos en solucionar la necesidad de una empresa mediante una alianza estratégica entre estudiantes talentosos con ganas de aprender y compañias que buscan solucionar un problema. Para lograr esto establecemos grupos multidisciplinairos de trabajo en donde conjuntamente la empresa trabaja de la mano de los estudiantes para relver la necesidad.',
    buttonLabel: 'Learn More',
    imgStart: false,
    img: require('../../images/svg-1.svg').default,
    alt: 'Software',
    dark: false,
    primary: true,
    darkText: false,
    href: "https://www.instagram.com/analytics.club.ac/",
};

export const homeObjTwo = {
    id: 'about',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'ÁREA',
    headLine: 'Emprendimiento',
    description: 'En esta área del club nos enfocamos principalemente en dos tipos de proyectos relacionados con emprendimientos. En primer lugar buscamos pimes y startups que estén empezando a constituirse y que estén interesados en realizar proyectos conjuntos con estudiantes del club. Por otro lado, también fomentamos la creación de empredimientos que surjan de ideas de estudiantes y que sea desarrollados por ellos mismos.',
    buttonLabel: 'Learn More',
    imgStart: true,
    img: require('../../images/svg-2.svg').default,
    alt: 'Industrial',
    dark: true,
    primary: false,
    darkText: true,
    href: "https://www.instagram.com/analytics.club.ac/",

};
export const homeObjThree = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'ÁREA',
    headLine: 'Impacto',
    description: 'El área de impacto busca desarrollar iniciativas con impacto social. Creemos que somos un grupo de estudiantes con muchas capacidades que nos permiten ayudar a otros y generar un cambio en nuestro país. ',
    buttonLabel: 'Learn More',
    imgStart: false,
    img: require('../../images/svg-3.svg').default,
    alt: 'Avion',
    dark: false,
    primary: true,
    darkText: false,
    href: "https://www.instagram.com/analytics.club.ac/",
};


export const homeObjFour = {
    id: 'about',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'ÁREA',
    headLine: 'Periodísmo',
    description: 'En esta parte del club nos encargamos de redactar artículos, noticias y post informativos relacionados con temas de AI, análisis de datos, innoveación y entre otros.',
    buttonLabel: 'Learn More',
    imgStart: true,
    img: require('../../images/svg-4.svg').default,
    alt: 'Avion',
    dark: true,
    primary: false,
    darkText: true,
    href: "https://www.instagram.com/analytics.club.ac/",
};

